import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DropdownDialogOption {
  label: string;
  value: string;
}

export interface DropdownDialogData {
  selected: DropdownDialogOption;
  options: DropdownDialogOption[];
}

@Component({
  selector: 'app-dropdown-dialog',
  templateUrl: './dropdown-dialog.component.html',
  styleUrls: ['./dropdown-dialog.component.scss'],
  standalone: false,
})
export class DropdownDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: DropdownDialogData,
    public dialogRef: MatDialogRef<DropdownDialogComponent>,
  ) {
    this.dialogRef.addPanelClass('dropdown-dialog-wrapper');
  }
}
